import React from "react";
import Tooltip from "rc-tooltip";

import "./tooltip.scss";

function GrigoraTooltip({ children, text, placement = "left", ...props }) {
  if (text) {
    return (
      <Tooltip
        placement={placement}
        overlay={text}
        // visible={true}
        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
        {...props}
      >
        {children}
      </Tooltip>
    );
  }
  return <>{children}</>;
}

export default GrigoraTooltip;
